<template>
  <div class="maskCon pf pr" v-if="visible">
    <div class="inMaskCon pa center">
      <h3 class="fw pr f16">{{ title }} <i class="closeIcon f30 pa cp" @click="visible = false">×</i></h3>
      <div class="inCon f12 addPro">
        <Form :label-width="120" v-if="type == 0">
          <FormItem label="父进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="子进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:380px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-else-if="type == 1">
          <FormItem label="进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="文件">
            <Select style="width:140px;">
              <Option v-for="item in fileList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:380px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="文件权限">
            <CheckboxGroup>
              <Checkbox>文件创建</Checkbox>
              <Checkbox>文件打开</Checkbox>
              <Checkbox>文件删除</Checkbox>
              <Checkbox>文件读书</Checkbox>
              <Checkbox>文件写入</Checkbox>
              <Checkbox>文件重命名</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-else-if="type == 2">
          <FormItem label="进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="模块">
            <Select style="width:140px;">
              <Option v-for="item in modelList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:380px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-else-if="type == 3">
          <FormItem label="进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="目标地址">
            <Select style="width:140px;">
              <Option v-for="item in tagetList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:210px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Button disabled style="margin-left:10px;">端口</Button>
            <Input style="width:100px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:380px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="协议支持">
            <CheckboxGroup>
              <Checkbox>TCP</Checkbox>
              <Checkbox>UDP</Checkbox>
              <Checkbox>ICMP</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-else-if="type == 4">
          <FormItem label="进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="键值路径">
            <Select style="width:140px;">
              <Option v-for="item in registerList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:380px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:380px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="注册表权限">
            <CheckboxGroup>
              <Checkbox>注册表创建</Checkbox>
              <Checkbox>注册表打开</Checkbox>
              <Checkbox>注册表删除</Checkbox>
              <Checkbox>注册表读取</Checkbox>
              <Checkbox>注册表写入</Checkbox>
              <Checkbox>注册表重命名</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-else-if="type == 5">
          <FormItem label="驱动">
            <Select style="width:140px;">
              <Option v-for="item in registerList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:380px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-else-if="type == 6">
          <FormItem label="驱动">
            <Select style="width:140px;">
              <Option v-for="item in registerList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:380px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="回调类型">
            <Select style="width:140px;">
              <Option v-for="item in callBackList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-else-if="type == 7">
          <FormItem label="注入进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="被注入进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:380px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-else-if="type == 8">
          <FormItem label="注入进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:518px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="窗口标题">
            <Input style="width:518px;" placeholder="" />
          </FormItem>
          <FormItem label="窗口类名">
            <Input style="width:518px;" placeholder="" />
          </FormItem>
          <FormItem label="窗口宽度">
            <Input style="width:194px;" placeholder="" />
            <span class="tar" style="width:120px;display: inline-block;margin-right: 10px;">窗口高度</span>
            <Input style="width:194px;" placeholder="" />
          </FormItem>
          <FormItem label="窗口X坐标">
            <Input style="width:194px;" placeholder="" />
            <span class="tar" style="width:120px;display: inline-block;margin-right: 10px;">窗口Y坐标</span>
            <Input style="width:194px;" placeholder="" />
          </FormItem>
          <FormItem label="窗口样式">
            <Input style="width:194px;" placeholder="" />
            <span class="tar" style="width:120px;display: inline-block;margin-right: 10px;">窗口扩展样式</span>
            <Input style="width:194px;" placeholder="" />
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-if="type == 9">
          <FormItem label="枚举窗口进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="被枚举窗口进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:380px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-if="type == 11">
          <FormItem label="破坏者进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="被保护进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:380px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="保护权限">
            <CheckboxGroup>
              <Checkbox>结束进程</Checkbox>
              <Checkbox>挂起进程</Checkbox>
              <Checkbox>创建远线程</Checkbox>
              <Checkbox>写入内存</Checkbox>
              <Checkbox>读取内存</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
        <Form :label-width="120" v-if="type == 12">
          <FormItem label="枚举进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
            <Checkbox border class="checkBg">匹配子进程</Checkbox>
          </FormItem>
          <FormItem label="被枚举进程">
            <Select style="width:140px;">
              <Option v-for="item in perPoress" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Input style="width:240px;margin-left: -1px;" v-model="formItem.input" placeholder="支持通配符*？"></Input>
          </FormItem>
          <FormItem label="匹配子进程级数">
            <Input style="width:380px;" placeholder="255表示匹配所有子进程" />
          </FormItem>
          <FormItem label="操作系统">
            <CheckboxGroup>
              <Checkbox>Win7</Checkbox>
              <Checkbox>Win10</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="处理方式">
            <Select style="width:140px;">
              <Option v-for="item in treatment" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="日志状态">
            <switchc :value="isOpen" @change="change">开启</switchc>
          </FormItem>
          <FormItem label="备注">
            <textarea></textarea>
          </FormItem>
          <FormItem label="">
            <Button type="info" style="margin-right:10px;">继续添加</Button>
            <Button type="info">提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import switchc from '_c/switch/switch';
export default {
  components: {
    switchc
  },
  props: ['title', 'type'],
  data () {
    return {
      visible: false,
      isOpen: false,
      formItem: {
        input: ''
      },
      callBackList: [
        {
          label: '进程回调',
        },
        {
          label: '线程回调',
        },
        {
          label: '注册表回调',
        },
        {
          label: '模块回调',
        }
      ],
      driveList: [
        {
          label: '驱动路径'
        },
        {
          label: '驱动名字'
        },
        {
          label: '驱动文件特征码'
        },
        {
          label: '驱动签名序列码'
        },
        {
          label: '驱动签名名字'
        },
      ],
      registerList: [
        {
          label: '注册表路径'
        },
        {
          label: '注册表名称'
        }
      ],
      tagetList: [
        {
          value: '',
          label: 'IP端口'
        },
        {
          value: '',
          label: '域名'
        },
        {
          value: '',
          label: 'HTTP'
        }
      ],
      modelList: [
        {
          label: '模块名字'
        },
        {
          label: '模块路径'
        },
        {
          label: '模块文件特征码'
        },
        {
          label: '模块签名序列号'
        },
        {
          label: '模块签名名字'
        }
      ],
      fileList: [
        {
          label: '文件名字'
        },
        {
          label: '文件路径'
        }

      ],
      treatment5: [
        {
          label: '拦截',
          value: 1,
        },
        {
          label: '拦截并结束当前父进程',
          value: 2,
        },
        {
          label: '拦截并挂起当前父进程',
          value: 3,
        },
        {
          label: '拦截并结束线程',
          value: 4,
        },
        {
          label: '拦截并挂起线程',
          value: 5,
        },
        {
          label: '拦截并挂起进程',
          value: 6,
        },
        {
          label: '拦截并结束进程',
          value: 7,
        },
        {
          label: '仅放行（白名单）',
          value: 8,
        },
      ],
      treatment: [
        {
          label: '拦截',
          value: ''
        },
        {
          label: '放行（白名单）',
          value: ''
        },
        {
          label: '拦截并结束父进程',
          value: ''
        },
        {
          label: '拦截并挂起父进程',
          value: ''
        },
        {
          label: '拦截并结束父线程',
          value: ''
        },
        {
          label: '拦截并挂起父线程',
          value: ''
        },
        {
          label: '挂起子进程',
          value: ''
        },
        {
          label: '结束子进程',
          value: ''
        },
      ],

      perPoress: [
        {
          label: '进程路径',
          value: 'dir'
        },
        {
          label: '进程名称',
          value: 'name'
        },
        {
          label: '文件特征码',
          value: 'spe'
        },
        {
          label: '进程签名序列号',
          value: 'sign'
        },
        {
          label: '进程签名名字',
          value: 'signName'
        }
      ]
    }
  },
  methods: {
    confirm () {
      console.log(122)
    },
    change (e) {
      this.isOpen = e
    }
  },
}
</script>
<style lang="scss" scoped>
.maskCon {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: .5);
  z-index: 99;

  .inMaskCon {
    width: 700px;
    background: #fff;
    box-shadow: 0 1px 3px rgba($color: #000000, $alpha: .3);

    h3 {
      line-height: 50px;
      text-indent: 20px;
      background: #F8F8F8;
      font-size: 14px;
      border-bottom: 1px solid #eee;
    }

    .closeIcon {
      right: 20px;
    }

    .inCon {
      padding: 20px;
    }
  }
}
</style>
<style lang="scss">
.addPro {

  .ivu-select-selection,
  .ivu-checkbox-wrapper,
  .ivu-btn,
  .ivu-input {
    border-radius: 0;
  }

  .ivu-checkbox-wrapper {
    margin-left: -1px;
    vertical-align: middle;
    width: 140px;

    span {
      margin-right: 4px;
    }
  }

  .checkBg {
    .ivu-checkbox-wrapper {
      background: #F5F7FA;
      z-index: 9;
    }
  }

  .ivu-select-single .ivu-select-selection {
    background: #F5F7FA;
    z-index: 9;
  }

  textarea {
    border: 1px solid #dcdee2;
    width: 340px;
    height: 90px;
    padding: 0 10px;
    box-sizing: border-box;
  }
}
</style>